export const API_PATH_ApiLanePlanningSearchItemsGet = '/services/lane-planning/apiLanePlanningSearchItemsGet';
